export default class InboundLimitTierSetDocument {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.inboundLimitTierSetId = jsonResponse["inbound-limit-tier-set-id"];
        this.documentPurpose = jsonResponse["document-purpose"];
        this.documentPurposeDisplayValue = jsonResponse["document-purpose-display-value"];
    }

}
